import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import { Button, Modal, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import $ from 'jquery';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Followup_Report = ({ show, onClose, selectedId, refresh, count, name, mobile, email }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // update data
    const [appdate, setDBDate] = useState(null);
    const [apptime, setDBTime] = useState(null);
    const [comments, setcomments] = useState(null);
    // display data
    const [appointmentdate, setDate] = useState(null);
    const [appointmenttime, setTime] = useState(null);
    useEffect(() => {
        const fetchdetails = async () => {
            try {
                const response = await axios.get(`${baseURL}/leadfollowup/${selectedId}`);
                setDate(response.data.appointment_date);
                setTime(response.data.appointment_time);
                // setDBDate(response.data.app_date);
                let time = response.data.app_time;
                let formattedTime = time.split(':').slice(0, 2).join(':');
                // setDBTime(formattedTime);
            } catch (error) {
                console.error('Error fetching lead types:', error);
            }
        };

        fetchdetails();
    }, []);

    // progress details
    const [isDisVisible, setIsDisVisible] = useState({
        completed: true,
        cancelled: false
    });
    const DistoggleDiv = (section) => {
        setIsDisVisible((prev) => ({
            completed: section === 'completed',
            cancelled: section === 'cancelled',
        }));
    };

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // page table data fetch
    const fetchData = () => {
        axios.get(`${baseURL}/leadfollowup/all/${selectedId}`)
            .then(response => {
                setData(response.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, []);

    // followup reason
    const [resonoption, setreasonoption] = useState([]);
    useEffect(() => {
        const fetchopt = async () => {
            try {
                const response = await axios.get(`${baseURL}/followupreason/getactive`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.name,
                }));
                setreasonoption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchopt();
    }, []);

    // pagination for follow up history
    const tableRef = useRef(null);
    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "230px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":

                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // capsfirst
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    // update followup details
    const [progress, setProgress] = useState(0);
    const [score, setScore] = useState(0);
    const [conversation, setConversation] = useState('');
    const [reason, setReason] = useState('');
    const [re_appointment_date, setReDate] = useState('');
    const [re_appointment_time, setReTime] = useState('');

    const handleNewDateChange = (dateValue) => {
        if (dateValue) {
            const formattedDate = dateValue.format('YYYY-MM-DD');
            setDBDate(formattedDate);
        } else {
            setDBDate('');
        }
    };

    const handleNewTimeChange = (timeValue) => {
        if (timeValue) {
            const formattedTime = timeValue.format('HH:mm');
            setDBTime(formattedTime);
        } else {
            setDBTime('');
        }
    };

    const handleDateChange = (dateValue) => {
        if (dateValue) {
            const formattedDate = dateValue.format('YYYY-MM-DD');
            setReDate(formattedDate);
        } else {
            setReDate('');
        }
    };

    const handleTimeChange = (timeValue) => {
        if (timeValue) {
            const formattedTime = timeValue.format('H:mm');
            setReTime(formattedTime);
        } else {
            setReTime('');
        }
    };

    // on submit 
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!appdate) {
            newErrors.date = "This Field is Required.";
        }
        
        if (!apptime) {
            newErrors.time = "This Field is Required.";
        }

        if(!comments){
            newErrors.comments = "This Field is Required.";
        }
      
        // Check if "product_type" radio button is selected
        // if (!isDisVisible.completed && !isDisVisible.cancelled) {
        //   newErrors.product_type = "This Field is Required.";
        // }
      
        // // Check if "size_type" radio button is selected when "Completed" is selected
        // if (isDisVisible.completed && (score === 0)) {
        //   newErrors.size_type = "Please select a score (Positive, Negative, or Neutral).";
        // }
      
        // Check if the "conversation" textarea is filled
        // if (isDisVisible.completed && !conversation.trim()) {
        //   newErrors.conversation = "This Field is Required.";
        // }
      
        // Check if the "reason" textarea is filled when "Cancelled" is selected
        // if (isDisVisible.cancelled && !reason.trim()) {
        //   newErrors.reason = "This Field is Required.";
        // }
      
        // Check if "re_appointment_date" is filled when "Cancelled" is selected
        // if (isDisVisible.cancelled && !re_appointment_date) {
        //   newErrors.re_appointment_date = "This Field is Required.";
        // }
      
        // Check if "re_appointment_time" is filled when "Cancelled" is selected
        // if (isDisVisible.cancelled && !re_appointment_time) {
        //   newErrors.re_appointment_time = "This Field is Required.";
        // }
      
        return newErrors;
    };
    
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // let clr = null;
        // let bord = null;
        // if (score === 0) {
        //     clr = '#ADD8E6';
        //     bord = '#7BAED9';
        // } else if (score === 1) {
        //     clr = '#e7ffcb';
        //     bord = '#78b636';
        // } else if (score === -1) {
        //     clr = '#FFB3B3';
        //     bord = '#D95B5B';
        // } else if (score === '') {
        //     clr = '';
        //     bord = '';
        // }

        const postData = { 
            lead: selectedId,
            appointment_date: appdate,
            appointment_time: apptime,
            score: null,
            progress: null,
            comments: comments,
            // conversation: conversation,
            // reason: reason,
            // re_appointment_date: re_appointment_date,
            // re_appointment_time: re_appointment_time,
            // followup_score_bg: clr,
            // followup_score_border: bord,
            created_by: user_id,
            branch_id: branch_id
        };
        axios.post(`${baseURL}/leadfollowup`, postData)
            .then(response => {
                onClose();
                refresh();
                count();
                toast.success("Followup Scheduled Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Followup Schedule Failed");
            });
    };

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    }


    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">New Followup</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                                <label className='text-black fs-6 font-w500'>{name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                <label className='text-black fs-6 font-w500'>{mobile}</label>
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Followup Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        onChange={handleNewDateChange}
                                        format="DD-MM-YYYY"
                                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    />
                                </div>
                                {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Followup Time<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-clock fs-4'></i>
                                    </div>
                                    <DatePicker placeholder='Select Time'
                                        disableDayPicker
                                        onChange={handleNewTimeChange}
                                        format="hh : mm A"
                                        showTime={{
                                            format: "hh:mm A", // 12-hour format for display
                                            use12Hours: true, // 12-hour clock
                                        }}
                                        plugins={[
                                            <TimePicker />
                                        ]}
                                    />
                                </div>
                                {errors.time && <div className="text-danger fs-8 mt-1">{errors.time}</div>}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Comments<span className="required">*</span></label>
                                <input class="form-control" type="text" placeholder=" Enter Comments.."
                                    maxLength={255}
                                    value={comments} 
                                    onChange={(e) => setcomments(e.target.value)}
                                />
                                {errors.comments && <div className="text-danger fs-8 mt-1">{errors.comments}</div>}
                            </div>
                            {datas.length>0 ?(
                                <div className='col-lg-12 mb-2'>
                                    <label className="text-black font-w600 fs-5 mb-3">Follow Up History</label>
                                    <div className="table-container"  >
                                        <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-80px text-start'>Date / Time</th>
                                                    <th className='min-w-50px text-center'>Score</th>
                                                    <th className='min-w-100px'>Conversation</th>
                                                    <th className='min-w-80px'>Reschedule</th>
                                                    <th className='min-w-100px'>Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {datas.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <label className='text-black font-w400 fs-7'>{formatDate(data.appointment_date)}</label>
                                                            <div className='d-block'>
                                                                <label className='text-dark font-w600 fs-8'>{convert24to12(data.appointment_time)}</label>
                                                            </div>
                                                        </td>
                                                        <td className='text-center'>
                                                            <label className='text-black font-w400 fs-7'>
                                                                <span>{data.score != null ? data.score : '-'}</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            {data.conversation ? (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.conversation}</span></Tooltip>} >
                                                                <label className='text-black font-w400 fs-7 w-100px text-truncate'>
                                                                    {data.conversation}
                                                                </label>
                                                            </OverlayTrigger>):
                                                            (
                                                                <div className='text-truncate mw-300px text-black font-w400 fs-7'>-</div>
                                                            )}
                                                        </td>
                                                        {data.re_appointment_date ? (
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{formatDate(data.re_appointment_date)}</label>
                                                                <div className='d-block'>
                                                                    <label className='text-dark font-w600 fs-8'>{convert24to12(data.re_appointment_time)}</label>
                                                                </div>
                                                            </td>
                                                        ) : (
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>-</label>
                                                            </td>
                                                        )}
                                                        <td>
                                                        {data.reason ? (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.reason}</span></Tooltip>} >
                                                                <label className='text-black font-w400 fs-7 w-100px text-truncate'>
                                                                    {data.reason}
                                                                </label>
                                                            </OverlayTrigger>):
                                                            (
                                                                <div className='text-truncate mw-300px text-black font-w400 fs-7'>-</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ): null}
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary" >Followup Schedule<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default Followup_Report;
